export const GET_LABOR_RATE = "GET_LABOR_RATE";
